import { useMutation } from "@shared/lib/hooks";
import { BriefService } from "../services/brief.service";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_INFLUENCER_V2_DELIVERABLE_QUERY_KEY,
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
} from "../constants";
import { ISkipConfirmationRequest } from "@shared/lib/types/briefInfluencerV2";

export function useSkipConfirmationMail(briefId: string) {
  const {
    mutate: skipConfirmationMail,
    isLoading: isSkippingConfirmationMail,
    isSuccess: isSkippedConfirmationMail,
  } = useMutation({
    mutationFn: (data: ISkipConfirmationRequest) =>
      BriefService.skipConfirmationMail(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_DELIVERABLE_QUERY_KEY],
      });
    },
  });

  return {
    skipConfirmationMail,
    isSkippingConfirmationMail,
    isSkippedConfirmationMail,
  };
}
